const MESES = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

export const paraData = (valor: string | null | undefined): Date | null => {
  if (!valor) return null;
  const data = new Date(valor);
  return Number.isNaN(data.getTime()) ? null : data;
};

export const dataCurta = (valor: string | Date | null | undefined): string | null => {
  const data = valor instanceof Date ? valor : paraData(valor);
  if (!data) return null;
  const dia = String(data.getDate()).padStart(2, "0");
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  return `${dia}/${mes}/${data.getFullYear()}`;
};

export const mesCurto = (yearMonth: string): string => {
  const [ano, mes] = yearMonth.split("-");
  const indice = Number(mes) - 1;
  if (!ano || Number.isNaN(indice) || indice < 0 || indice > 11) return yearMonth;
  return `${MESES[indice]}/${ano}`;
};

export const numero = (valor: number): string => valor.toLocaleString("pt-BR");

export const moeda = (valor: number): string =>
  valor.toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 });

/** O backend concatena "Cidade, UF" mesmo quando a UF é nula ("São José, null"). */
export const lugarLimpo = (valor: string | null | undefined): string =>
  (valor ?? "")
    .split(",")
    .map((parte) => parte.trim())
    .filter((parte) => parte && parte.toLowerCase() !== "null" && parte.toLowerCase() !== "undefined")
    .join(", ");

export const diasEntre = (inicio: Date, fim: Date): number =>
  Math.floor((fim.getTime() - inicio.getTime()) / 86_400_000);

export const primeiraFrase = (texto: string, limite = 90): string => {
  const limpo = texto.replace(/\s+/g, " ").trim();
  const corte = limpo.search(/[.!?]\s|\n/);
  const frase = corte > 0 ? limpo.slice(0, corte + 1) : limpo;
  return frase.length > limite ? `${frase.slice(0, limite - 1).trimEnd()}…` : frase;
};
